/**
 * Phân trang cho tin nhắn và danh sách hội thoại (truy vấn nhiều trang — useInfiniteQuery).
 *
 * Backend phân trang theo số trang (`page` + `limit`), trang 1 = MỚI NHẤT. Làm mới (invalidate) tải lại TẤT CẢ trang
 * đã mở cùng lúc theo số trang nên không hở khoảng giữa các trang khi có tin mới dồn xuống; tin/hội thoại trùng ở
 * ranh giới giữa hai trang (do dịch dòng giữa hai lần tải) được gộp theo id.
 */

interface PageMeta {
  page: number
  limit: number
  total: number
}

/** Còn trang cũ hơn chưa tải? (trang cuối đã tải chưa phủ hết `total`). */
export function nextPageParam(last: PageMeta, itemCount: number): number | undefined {
  if (itemCount === 0) return undefined
  return last.page * last.limit < last.total ? last.page + 1 : undefined
}

/**
 * Gộp các trang tin nhắn thành một danh sách tăng dần theo thời gian (cũ → mới), như màn chat cần.
 * `pages[0]` là trang mới nhất, mỗi trang đã sắp tăng dần (backend đảo lại trước khi trả).
 */
export function flattenMessagePages<M extends { id: string }>(pages: { messages: M[]; total: number }[]): { messages: M[]; total: number } {
  const seen = new Set<string>()
  const out: M[] = []
  for (let i = pages.length - 1; i >= 0; i--) {
    for (const m of pages[i].messages) {
      if (seen.has(m.id)) continue
      seen.add(m.id)
      out.push(m)
    }
  }
  return { messages: out, total: pages[0]?.total ?? 0 }
}

/** Gộp các trang danh sách hội thoại theo thứ tự backend trả (mới hoạt động → cũ), bỏ trùng id. */
export function flattenConversationPages<C extends { id: string }>(pages: { conversations: C[]; total: number }[]): { conversations: C[]; total: number } {
  const seen = new Set<string>()
  const out: C[] = []
  for (const p of pages) {
    for (const c of p.conversations) {
      if (seen.has(c.id)) continue
      seen.add(c.id)
      out.push(c)
    }
  }
  return { conversations: out, total: pages[0]?.total ?? 0 }
}
